module.exports = __webpack_public_path__ + "55685e8f742420f78dd7599010fb1c6a.pdf";